<template>
  <div class="pricing-curve--blurred">
    <img :src="`${baseUrl}images/blurredcurve.jpg`" alt="Blurred Pricing Curve" />
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';

@Component
export default class BlurredPricingCurveComponent extends Vue {
  public get baseUrl() {
    return process.env.BASE_URL;
  }
}
</script>
